import {connect} from 'react-redux';
import LocaleProvider from './LocaleProvider';
import {DEFAULT_LOCALE} from '../config';

const mapStateToProps = state => {
  const {locale} = state.intl;
  const messages = state.intl.messages[locale];
  return {
    locale,
    messages,
    defaultLocale: DEFAULT_LOCALE
  };
};

export default connect(mapStateToProps)(LocaleProvider);
